export const BASE_URL = 'https://scotclans-new.staging.civiccomputing.com';

export const wooClientKey = 'ck_24cd163904648afc435526d178180c9594624161';
export const wooClientSecret = 'cs_38ff21906cbbbe65351b9d6918959e1d0500ce95';
